<div *ngIf="pathImage">
  <img [src]="pathImage" aria-label="Usuario" class="large-avatar">
</div>
<div *ngIf="!pathImage" [matTooltip]="tipoUsuario==null?'':tipoUsuario">
  <span class="large-avatar" [style.background-color]="color$ | async">
    {{iniciales$ | async}}
  </span>
</div>
